export default __webpack_public_path__ + "static/media/coresanscr55-webfont.5f8d1ddd.woff";